// src/services/emailService.js
import emailjs from '@emailjs/browser';

// KONFIGURACIJA - EmailJS podaci
const EMAILJS_CONFIG = {
  SERVICE_ID: 'service_8q7wppt',      // EmailJS Service ID
  TEMPLATE_ID: 'template_ifmbovm',    // EmailJS Template ID
  PUBLIC_KEY: 'Vkp4mzW1gmJUor_t8',    // EmailJS Public Key
};

/**
 * Šalje email preko EmailJS servisa
 * @param {Object} formData - Podaci iz kontakt forme
 * @param {string} formData.name - Ime i prezime korisnika
 * @param {string} formData.email - Email korisnika
 * @param {string} formData.message - Poruka korisnika
 * @returns {Promise} Promise koji se resolve-uje ako je email uspješno poslan
 */
export const sendEmail = async (formData) => {
  try {
    // Priprema podataka za template
    // VAŽNO: Nazivi varijabli moraju odgovarati onima u EmailJS template-u
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      message: formData.message,
      to_email: 'dizajn.kbia@gmail.com',
    };

    // Debug: prikaži što se šalje
    console.log('EmailJS - Šaljem podatke:', templateParams);

    // Slanje emaila - noviji API ne zahtijeva init() prije svakog poziva
    const response = await emailjs.send(
      EMAILJS_CONFIG.SERVICE_ID,
      EMAILJS_CONFIG.TEMPLATE_ID,
      templateParams,
      EMAILJS_CONFIG.PUBLIC_KEY // Public Key se prosljeđuje kao 4. parametar
    );

    console.log('Email uspješno poslan!', response.status, response.text);
    return { success: true, message: 'Email je uspješno poslan!' };
  } catch (error) {
    console.error('Greška pri slanju emaila:', error);
    console.error('Detalji greške:', {
      status: error.status,
      text: error.text,
      message: error.message,
    });
    return {
      success: false,
      message: error.text || error.message || 'Greška pri slanju emaila. Molimo pokušajte ponovno.',
      error: error.text || error.message,
    };
  }
};

